var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{staticClass:"nav"},[_c('Logo'),_c('router-link',{staticClass:"tf-button tf-button--narrow",attrs:{"to":"/add"}},[_vm._v(" Add/Change summoner ")])],1),_c('Intro'),_c('SummonerList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }